import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { RouteTag } from '@frontend/sports/common/core/data-access/route';

import { PrintGuard } from '../print/print.guard';
import { SportRoute } from '../router/multi-route.model';
import { regexMatcher } from '../router/regex.matcher';
import { use } from '../router/router.resolver';
import { SitemapRoutingToken } from '../sitemap/sitemap-routing';
import MyBetsDetailsSubNavigationService from './components/details/my-bets-details-subnavigation.service';
import MyBetsDetailsComponent from './components/details/my-bets-details.component';
import MyBetsDetailsGuard from './components/details/my-bets-details.guard';
import MyBetsDetailsResolver from './components/details/my-bets-details.resolver';
import { MyBetsPrintEditBetHistoryComponent } from './components/print/my-bets-print-edit-bet-history.component';
import { MyBetsPrintEditBetHistoryResolver } from './components/print/my-bets-print-edit-bet-history.resolver';
import { MyBetsPrintComponent } from './components/print/my-bets-print.component';
import { MyBetsPrintResolver } from './components/print/my-bets-print.resolver';
import { MyBetsBreadcrumbsResolver } from './my-bets-breadcrumbs.resolver';
import { MyBetsRouteComponent } from './my-bets-route.component';
import { MyBetsSubnavigationResolveService } from './my-bets-subnavigation/my-bets-subnavigation.service';
import { MyBetsResolver } from './my-bets.resolver';
import { MyBetsGuard } from './services/my-bets-guard';

const routes: SportRoute[] = [
    {
        path: '',
        data: {
            htmlClass: 'my-bets',
            headerNavigation: true,
            authorized: true,
            topNavigationHiddenOnSmallScreen: true,
            subNavigation: MyBetsSubnavigationResolveService,
            breadcrumbs: MyBetsBreadcrumbsResolver,
            sitemap: SitemapRoutingToken.SitemapEmptyResolver,
            shouldKeepBreadcrumbs: true,
        },
        children: [
            {
                path: '',
                canActivate: [MyBetsGuard],
                component: MyBetsRouteComponent,
                resolve: use(MyBetsResolver),
            },
            {
                path: 'print',
                component: MyBetsPrintComponent,
                resolve: use(MyBetsPrintResolver),
                canActivate: [PrintGuard],
                data: {
                    htmlClass: 'print-view',
                    disableScroll: true,
                },
            },
            {
                path: 'print/edit-my-bet-history',
                component: MyBetsPrintEditBetHistoryComponent,
                resolve: use(MyBetsPrintEditBetHistoryResolver),
                canActivate: [PrintGuard],
                data: {
                    htmlClass: 'print-view',
                    disableScroll: true,
                },
            },
            {
                path: 'details/:betNumber',
                component: MyBetsDetailsComponent,
                resolve: use(MyBetsDetailsResolver),
                canActivate: [MyBetsDetailsGuard],
                data: {
                    subNavigation: MyBetsDetailsSubNavigationService,
                    tag: RouteTag.MyBets,
                },
            },
            {
                matcher: regexMatcher,
                data: {
                    matcherPattern: '^({open}|{settled}|{live})$',
                    matcherMapping: {
                        tab: 1,
                    },
                    tag: RouteTag.MyBets,
                },
                component: MyBetsRouteComponent,
                resolve: use(MyBetsResolver),
            },
            {
                path: '**',
                redirectTo: '',
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MyBetsRoutingModule {}
